import React, { Component } from 'react';
import Grid from "@mui/material/Grid";
import Switch from '../../../components/Switch.js';
import Bubble from '../../../components/Bubble.js';
import BubbleSelectBlock from '../../../components/BubbleSelectBlock.js';
import NumberInput from '../../../components/TextFields/NumberInput.js';
import Text from '../../../components/Text.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import BlockContent from '../../../components/BlockContent.js';
import HeaderDiv from '../../../components/HeaderDiv.js';
import { colors } from '../../../theme/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import { selectFieldOptions } from '../../../services/index.js';
import * as localizationMaps from '../../../localization/maps.js';
class LTD extends Component {
  state = {
    data: null
  };
  componentDidMount() {
    const defaults = this._setData(this.props.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      // tier, tierBenefit, benefit, data

      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, null, null, 'ltd', defaults);
      return;
    }

    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'ltd', defaults);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const defaults = this._setData(nextProps.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      return;
    }
    if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'ltd', defaults);
    }
  }
  _setData = data => {
    const defaults = {
      isSelected: data.isSelected || false,
      isGraded: data.isGraded === undefined ? true : data.isGraded,
      isFlatAmount: data.isFlatAmount || false,
      isTaxable: data.isTaxable || false,
      includeAllowPreExistingConditions: data.includeAllowPreExistingConditions || false,
      includeCostOfLivingAdjustments: data.includeCostOfLivingAdjustments || false,
      costOfLivingAdjustmentsPercentage: data.costOfLivingAdjustmentsPercentage || 3,
      includeLumpSumPaymentDisabledParticipantsDeath: data.includeLumpSumPaymentDisabledParticipantsDeath || false,
      percentageOfFlatAmount: typeof data.percentageOfFlatAmount === "number" ? data.percentageOfFlatAmount : 66.67,
      maxNoEvidence: data.maxNoEvidence || 0,
      maxEvidence: data.maxEvidence || 0,
      benefitsPeriod: data.benefitsPeriod || 'To Age 65',
      elimPeriod: data.elimPeriod ? parseInt(data.elimPeriod, 10) : 119,
      defOfDisability: data.defOfDisability || "2 Year Own Occupation, Any Occupation Thereafter",
      firstMaxType: data.firstMaxType || 'Dollar Amount',
      secondMaxType: data.secondMaxType || 'Dollar Amount',
      thirdMaxType: data.thirdMaxType || 'Remainder',
      percentageFirstMax: data.percentageFirstMax || 0,
      percentageSecondMax: data.percentageSecondMax || 0,
      percentageThirdMax: data.percentageThirdMax || 0,
      firstMax: data.firstMax || 0,
      secondMax: data.secondMax || 0,
      thirdMax: data.thirdMax || 0,
      terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
      eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
      minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
      notes: data.notes || null
    };
    this.setState({
      data: {
        ...defaults
      }
    });
    return defaults;
  };
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        [field]: value
      }
    });
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, null, null, 'ltd', field, value);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'ltd', field, value);
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      classes,
      errors,
      whitelabel,
      isMasterSite,
      revision,
      isRevisionBlock
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    return /*#__PURE__*/React.createElement(BlockContent, {
      style: isRevisionBlock ? {
        backgroundColor: '#F7F9FA'
      } : null
    }, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `${i18n.t(tokens.titles.longTermDisability)} (${revision.revisionID})` : i18n.t(tokens.labels.planDesign.longTermDisabilityCurrent) : i18n.t(tokens.titles.longTermDisability)), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    })), isSelected && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectBetween)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.planDesign.gradedAmount),
        selected: data.isGraded,
        field: 'isGraded'
      },
      second: {
        title: i18n.t(tokens.labels.planDesign.flatAmount),
        selected: data.isFlatAmount,
        field: 'isFlatAmount'
      },
      handleChange: this._saveInGlobalState
    }), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectBetween)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.coverage.taxable),
        selected: data.isTaxable === true,
        field: 'isTaxable'
      },
      second: {
        title: i18n.t(tokens.labels.coverage.nonTaxable),
        selected: data.isTaxable === false,
        field: 'isTaxable'
      },
      handleChange: () => this._saveInGlobalState('isTaxable', !data.isTaxable)
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.allowPreExistingConditions),
      isSelected: data.includeAllowPreExistingConditions,
      onClick: () => this._saveInGlobalState("includeAllowPreExistingConditions", !data.includeAllowPreExistingConditions)
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.allowCostOfLivingAdjustments),
      isSelected: data.includeCostOfLivingAdjustments,
      onClick: () => this._saveInGlobalState("includeCostOfLivingAdjustments", !data.includeCostOfLivingAdjustments)
    }))), data.includeCostOfLivingAdjustments && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.costOfLivingAdjustmentPercentage),
      fullWidth: true,
      variant: "outlined",
      value: data.costOfLivingAdjustmentsPercentage,
      onChange: e => this._handleChange("costOfLivingAdjustmentsPercentage", e.target.value),
      onBlur: e => this._saveInGlobalState("costOfLivingAdjustmentsPercentage", e.target.value),
      error: errors.costOfLivingAdjustmentsPercentage,
      select: true,
      selectOptions: [{
        key: 1,
        value: 1
      }, {
        key: 2,
        value: 2
      }, {
        key: 3,
        value: 3
      }, {
        key: 4,
        value: 4
      }, {
        key: 5,
        value: 5
      }, {
        key: 6,
        value: 6
      }, {
        key: 7,
        value: 7
      }, {
        key: 8,
        value: 8
      }, {
        key: 9,
        value: 9
      }]
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.allowLumpSumPayment),
      isSelected: data.includeLumpSumPaymentDisabledParticipantsDeath,
      onClick: () => this._saveInGlobalState("includeLumpSumPaymentDisabledParticipantsDeath", !data.includeLumpSumPaymentDisabledParticipantsDeath)
    }))), !data.isGraded && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 24
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.percentageOfFlatAmount),
      fullWidth: true,
      suffix: "%",
      value: data.percentageOfFlatAmount,
      variant: "outlined",
      onChange: e => this._handleChange("percentageOfFlatAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("percentageOfFlatAmount", e.target.value),
      error: errors.percentageOfFlatAmount
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), data.isGraded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.percentageOfFirstMaximum),
      fullWidth: true,
      value: data.percentageFirstMax,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("percentageFirstMax", e.target.value),
      onBlur: e => this._saveInGlobalState("percentageFirstMax", e.target.value),
      error: errors.percentageFirstMax
    })), data.firstMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.percentageOfSecondMaximum),
      fullWidth: true,
      value: data.percentageSecondMax,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("percentageSecondMax", e.target.value),
      onBlur: e => this._saveInGlobalState("percentageSecondMax", e.target.value),
      error: errors.percentageSecondMax
    })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.percentageOfThirdMaximum),
      fullWidth: true,
      value: data.percentageThirdMax,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("percentageThirdMax", e.target.value),
      onBlur: e => this._saveInGlobalState("percentageThirdMax", e.target.value),
      error: errors.percentageThirdMax
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.firstMaximumType),
      fullWidth: true,
      value: localizationMaps.fromEnglish('planMaximumOptions', data.firstMaxType),
      variant: "outlined",
      onChange: e => this._handleChange("firstMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value)),
      onBlur: e => this._saveInGlobalState("firstMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value)),
      error: errors.firstMaxType,
      select: true,
      selectOptions: selectFieldOptions.planMaximumOptions()
    })), data.firstMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.secondMaximumType),
      fullWidth: true,
      value: localizationMaps.fromEnglish('planMaximumOptions', data.secondMaxType),
      variant: "outlined",
      onChange: e => this._handleChange("secondMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value)),
      onBlur: e => this._saveInGlobalState("secondMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value)),
      error: errors.secondMaxType,
      select: true,
      selectOptions: selectFieldOptions.planMaximumOptions()
    })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.thirdMaximumType),
      fullWidth: true,
      value: localizationMaps.fromEnglish('planMaximumOptions', data.thirdMaxType),
      variant: "outlined",
      onChange: e => this._handleChange("thirdMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value)),
      onBlur: e => this._saveInGlobalState("thirdMaxType", localizationMaps.toEnglish('planMaximumOptions', e.target.value)),
      error: errors.thirdMaxType,
      select: true,
      selectOptions: selectFieldOptions.planMaximumOptions()
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, data.firstMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.firstMaximum),
      fullWidth: true,
      value: data.firstMax,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("firstMax", e.target.value),
      onBlur: e => this._saveInGlobalState("firstMax", e.target.value),
      error: errors.firstMax
    })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.secondMaximum),
      fullWidth: true,
      value: data.secondMax,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("secondMax", e.target.value),
      onBlur: e => this._saveInGlobalState("secondMax", e.target.value),
      error: errors.secondMax
    })), data.firstMaxType === 'Dollar Amount' && data.secondMaxType === 'Dollar Amount' && data.thirdMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.thirdMaximum),
      fullWidth: true,
      value: data.thirdMax,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("thirdMax", e.target.value),
      onBlur: e => this._saveInGlobalState("thirdMax", e.target.value),
      error: errors.thirdMax
    })))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.nonEvidenceMaximum),
      fullWidth: true,
      prefix: "$ ",
      disabled: !isMasterSite,
      value: data.maxNoEvidence,
      onChange: e => this._handleChange("maxNoEvidence", e.target.value),
      onBlur: e => this._saveInGlobalState("maxNoEvidence", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.maximumWithEvidence),
      fullWidth: true,
      prefix: "$ ",
      disabled: !isMasterSite,
      value: data.maxEvidence,
      onChange: e => this._handleChange("maxEvidence", e.target.value),
      onBlur: e => this._saveInGlobalState("maxEvidence", e.target.value),
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.benefitsPeriod),
      fullWidth: true,
      value: localizationMaps.fromEnglish('benefitsPeriod', data.benefitsPeriod),
      variant: "outlined",
      onChange: async e => {
        const value = e.target.value;
        await this._handleChange("benefitsPeriod", localizationMaps.toEnglish('benefitsPeriod', value));
        if (localizationMaps.toEnglish("benefitsPeriod", value) === '2 Years') {
          this._handleChange("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
        } else if (localizationMaps.toEnglish("benefitsPeriod", value) === '5 Years') {
          this._handleChange("defOfDisability", '5 Year Own Occupation, Any Occupation Thereafter');
        } else {
          this._handleChange("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
        }
      },
      onBlur: async e => {
        const value = e.target.value;
        await this._saveInGlobalState("benefitsPeriod", localizationMaps.toEnglish('benefitsPeriod', value));
        if (localizationMaps.toEnglish("benefitsPeriod", value) === '2 Years') {
          this._saveInGlobalState("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
        } else if (localizationMaps.toEnglish("benefitsPeriod", value) === '5 Years') {
          this._saveInGlobalState("defOfDisability", '5 Year Own Occupation, Any Occupation Thereafter');
        } else {
          this._saveInGlobalState("defOfDisability", '2 Year Own Occupation, Any Occupation Thereafter');
        }
      },
      error: errors.benefitsPeriod,
      select: true,
      selectOptions: selectFieldOptions.defOfDisabilityOptions()
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.eliminationPeriodDays),
      fullWidth: true,
      value: parseInt(data.elimPeriod, 10),
      variant: "outlined",
      onChange: e => this._handleChange("elimPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("elimPeriod", e.target.value),
      error: errors.elimPeriod,
      select: true,
      selectOptions: [{
        key: 0,
        value: 91
      }, {
        key: 1,
        value: 105
      }, {
        key: 2,
        value: 112
      }, {
        key: 3,
        value: 116
      }, {
        key: 4,
        value: 119
      }, {
        key: 5,
        value: 120
      }, {
        key: 6,
        value: 121
      }, {
        key: 7,
        value: 182
      }]
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 8
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.definitionOfDisability),
      fullWidth: true,
      value: localizationMaps.fromEnglish('defOfDisability', data.defOfDisability),
      variant: "outlined",
      disabled: !isMasterSite,
      onChange: e => this._handleChange("defOfDisability", e.target.value),
      onBlur: e => this._saveInGlobalState("defOfDisability", e.target.value),
      select: true,
      selectOptions: selectFieldOptions.defOfDisabilityMapOptions()
    }))), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "20px 0 10px 0"
    }, i18n.t(tokens.labels.planDesign.planEligibilityTermination)), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.eligibilityPeriodMonths),
      fullWidth: true,
      value: data.eligibilityPeriod,
      variant: "outlined",
      onChange: e => this._handleChange("eligibilityPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("eligibilityPeriod", e.target.value),
      error: errors.eligibilityPeriod
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.minimumHoursPerWeek),
      fullWidth: true,
      value: data.minHoursPerWeek,
      variant: "outlined",
      onChange: e => this._handleChange("minHoursPerWeek", e.target.value),
      onBlur: e => this._saveInGlobalState("minHoursPerWeek", e.target.value),
      error: errors.minHoursPerWeek
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.terminationAge),
      fullWidth: true,
      value: data.terminationAge,
      variant: "outlined",
      onChange: e => this._handleChange("terminationAge", e.target.value),
      onBlur: e => this._saveInGlobalState("terminationAge", e.target.value),
      error: errors.terminationAge
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      margin: "20px 0 0 0",
      bold: true
    }, "Notes:"), /*#__PURE__*/React.createElement(TextInput, {
      fullWidth: true,
      value: data.notes || '',
      variant: "outlined",
      error: errors.notes,
      onChange: e => this._handleChange("notes", e.target.value),
      onBlur: e => this._saveInGlobalState("notes", e.target.value),
      multiline: true,
      rows: 5,
      placeholder: i18n.t(tokens.labels.planDesign.additionalRequestsInformation)
    })));
  }
}
export default LTD;